import { keyBy } from 'lodash'
import { POST } from '@/api'
import edit from './edit'

/**
 * 顧客情報追加項目
 */
export default {
  namespaced: true,
  state: {
    byId: {},
    allIds: [],
    busy: false,
  },
  modules: {
    edit,
  },
  mutations: {
    set(state, options) {
      state.byId = keyBy(options, 'id')
      state.allIds = options.map(option => option.id)
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    all(state) {
      return state.allIds.map(id => state.byId[id])
    },
  },
  actions: {
    async get(store) {
      const { commit } = store
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/option/customer/list')
      if (status === 200) {
        commit('set', data.options)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },

    async remove({ commit, state }, id) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/option/customer/delete', { id })
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },

    async saveOrder({ commit, state }, optionItemIds) {
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/option/customer/order', { optionItemIds })
      if (status !== 200) commit('app/error', { status, message }, { root: true })

      commit('busy', false)
      return status === 200
    },
  },
}
